/**
 * Tab Manager App Component Exports
 *
 * @since 1.0.0
 */

export { TabManagerApp } from './component';
export type { TabManagerAppProps } from './types';
